import { Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const ThemesConfigurationSkeleton = () => {
  return (
    <Styles.Container>
      <Skeleton variant="text" width="100%" height={20} />
      <Skeleton variant="text" width="80%" height={20} />

      <Styles.TabsRow>
        <Skeleton variant="rounded" width={140} height={36} />
        <Skeleton variant="rounded" width={140} height={36} />
      </Styles.TabsRow>

      <Skeleton variant="rounded" width="100%" height={48} />

      <Styles.ColumnsContainer>
        <Styles.LeftColumn>
          <Skeleton variant="text" width={180} height={24} />
          <Skeleton variant="rounded" width="100%" height={56} />
          <Skeleton variant="rounded" width="100%" height={56} />
          <Skeleton variant="rounded" width="100%" height={56} />
          <Skeleton variant="rounded" width="100%" height={56} />
          <Skeleton variant="rounded" width="100%" height={120} />
        </Styles.LeftColumn>

        <Styles.RightColumn>
          <Skeleton variant="rounded" width="100%" height={56} />
          <Skeleton variant="rounded" width="100%" height={400} />
        </Styles.RightColumn>
      </Styles.ColumnsContainer>
    </Styles.Container>
  )
}

export default ThemesConfigurationSkeleton
